<template>
  <GenericModuleForm
    :title="queueModuleName"
    :model-value="state.isActive"
    :loading="isLoading"
    :response-message="state.response.message"
    :response-type="state.response.type"
    help-center-key="queue_management_module_v002"
    description="Queue management enables students to enter a queue when maximum pass limit for a location has been reached or exceeded."
    @toggle="toggleQueueModule"
    @dismiss-response="resetResponse"
  />
</template>

<script>
import queueConfigs from "@/configs/queueConfigs"
import queueConstants from "@/constants/queueConstants"
import GenericModuleForm from "@/v3components/Forms/ModuleListForms/GenericModuleForm.vue"
import { computed, onMounted, reactive, ref } from "vue"
import { useRouter } from "vue-router"
import { useStore } from "vuex"

export default {
  name: "QueueManagementModuleForm",
  components: {
    GenericModuleForm
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const isLoading = ref(false)

    const state = reactive({
      response: {
        type: "",
        message: "",
        errors: {}
      },
      isActive: true
    })

    const isQueueModuleActive = computed(() => {
      return store.getters["queueSettings/isQueueModuleActive"]
    })

    const resetResponse = () => {
      state.response = {
        type: "",
        message: "",
        errors: {}
      }
    }

    const setSuccessResponse = (message) => {
      state.response = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    }

    const setErrorResponse = (message, errors) => {
      state.response = {
        type: "danger",
        message: message ? message : "Something went wrong!",
        errors: errors ? errors : {}
      }
    }

    const redirectToQueueAdultPage = () => {
      router.push(queueConfigs.pages.adultsPage().path)
    }

    const toggleQueueModule = async (status) => {
      if (isLoading.value) return

      isLoading.value = true
      try {
        resetResponse()
        await store.dispatch("modules/updateQueueModule", status)
        state.isActive = status
        await store.dispatch("schools/getActiveModules", {
          clearCacheEntry: true
        })
        setSuccessResponse("Module updated.")
      } catch (error) {
        const response = error.response ? error.response.data : {}
        setErrorResponse(response.message, response.errors)
      } finally {
        isLoading.value = false
      }
    }

    onMounted(() => {
      state.isActive = isQueueModuleActive.value
    })

    return {
      isLoading,
      queueModuleName: queueConstants.MODULE,
      state,
      toggleQueueModule,
      redirectToQueueAdultPage,
      resetResponse
    }
  }
}
</script>
